import { Button, ButtonRow, Heading, Text } from '@ksyos/design-system';
import type { IQuestionnaireFormProps } from '../../../Questionnaire';
import { StyledImg } from '../../../../../elements/atoms/styledImg/StyledImg';
import { CustomContainer } from '../../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../../elements/molecules/stack/Stack';

export function Intro(props: IQuestionnaireFormProps) {
    return (
        <>
            <CustomContainer>
                <Stack>
                    <Heading
                        as="h2"
                        size="xlarge"
                    >
                        FOSQ-10 vragenlijst
                    </Heading>
                </Stack>

                <Stack>
                    <StyledImg
                        alt="FOSQ-10 questionnaire intro"
                        src="/assets/images/somnology/questionnaires/fosq10-questionnaire-intro.svg"
                        srcSet="/assets/images/somnology/questionnaires/fosq10-questionnaire-intro.svg 1x, /assets/images/somnology/questionnaires/fosq10-questionnaire-intro.svg 2x, /assets/images/somnology/questionnaires/fosq10-questionnaire-intro.svg 3x,"
                    />
                </Stack>

                <Stack>
                    <Text>
                        Beantwoord hier 10 vragen waarmee je je slaaparts laat weten hoe het met je slaapklachten is
                        gegaan <b>in de afgelopen twee weken</b>.
                    </Text>
                </Stack>

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                        width="full-below-small"
                    >
                        Start vragenlijst
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
